// ورود با تلفن همراه
<template>
  <main>
    <div
      class="
        container
        min-vh-100
        d-flex
        justify-content-center
        align-items-center
      "
    >
      <div class="row justify-content-center">
        <div
          class="
            col-sm-11 col-md-9 col-lg-8
            bg-white
            rounded
            shadow
            z-depth-1
            my-2
            wow
            fadeIn
            p-0
          "
        >
          <div class="row">
            <!-- کادر رنگی سمت راست -->
            <div
              class="
                col-3
                bg-dark
                d-flex
                flex-column
                justify-content-between
                align-items-center
                rounded-right
                shadow
                z-depth-1
                p-0
                py-3
              "
            >
              <!-- لوگو و نام نرم افزار -->
              <div class="row">
                <div class="col text-center p-0">
                  <img
                    class="img-fluid px-4"
                    :src="ImageUrl + 'LogoSite.png'"
                    alt="LogoSite"
                  />
                  <span class="text-white" style="font-size: 12px"
                    >سامانه مالی پرش</span
                  >
                </div>
              </div>

              <!-- نگارش و امضاء -->
              <div class="row">
                <div class="col text-center p-0">
                  <span class="text-white d-block"
                    >نگارش : {{ getVersionApp }}</span
                  >
                  <span class="text-white d-block mt-2">پارس رایانه شاپرک</span>
                </div>
              </div>
            </div>

            <!-- مرکز فرم ورود -->
            <div class="col-9 p-5 p-md-5 d-flex flex-column text-right">
              <h4 class="mb-4 text-danger text-center">
                <strong>ورود با تلفن همراه</strong>
              </h4>
              <!-- مربوط به درج تلفن همراه جهت ارسال پیامک -->
              <div v-if="!checkSendSMS">
                <h6 class="text-center" style="line-height: 32px">
                    جهت ورود به سامانه ، تلفن همراه خود را در کادر زیر درج نموده و روی دکمه ارسال پیامک کلیک نمایید .
                </h6>
                <!-- کادر تلفن همراه -->
                <div class="input-group my-4">
                    <input
                        type="text"
                        v-model="mobilNumber"
                        class="form-control text-center rounded-0"
                        placeholder="تلفن همراه خود را وارد نمایید"
                        autocomplete="off"
                        v-on:focus="$event.target.select()"
                        v-on:keyup.enter="checkMobileNumber()"
                        v-on:keypress="onlyNumberAccept"
                        style="direction: ltr"
                        maxlength="11"
                    />
                </div>
                <div v-if="errorMessage != ''" class="row m-0 p-0 mb-3 justify-content-center">
                  <span 
                    class="h6 text-danger text-center"
                    style="white-space: pre; line-height: 28px;"
                  >{{errorMessage}}</span>
                </div>
                <!-- دکمه ارسال پیامک و بازگشت پایین فرم -->
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div
                      class="
                          d-inline-flex
                          justify-content-end
                          align-items-center
                          bg-secondary
                          rounded
                          hoverable
                          waves-effect
                      "
                    >
                      <a
                          v-on:click="checkMobileNumber()"
                          class="text-decoration-none px-4 py-2 text-white m-0 h6"
                      >
                          ارسال پیامک رمز یکبار مصرف
                      </a>
                      <a
                          v-on:click="checkMobileNumber()"
                          style="background-color: #623879"
                          class="
                          text-decoration-none
                          p-2
                          text-white
                          m-0
                          rounded-left
                          "
                      >
                        <i class="fas fa-sms fa-3x"></i>
                      </a>
                    </div>
                  </div>
                  <div
                    class="
                      d-inline-flex
                      justify-content-end
                    "
                  >
                    <a
                      v-on:click="backToLogin()"
                      class="
                        m-0
                        h7
                        text-info
                        mt-2
                      "
                      title="بازگشت به فرم ورود"
                    >
                      بازگشت
                      <i class="fas fa-sign-out-alt fa-rotate-180 fa-lg mr-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <!-- مربوط به درج رمز یکبار مصرف -->
              <div v-else>
                <h6 class="text-center" style="line-height: 32px">
                    پیامکی حاوی رمز یکبار مصرف برای شما ارسال شد .
                    <br />
                    رمز دریافتی را در کادر زیر درج نموده و سپس دکمه تایید و ورود را کلیک نمایید .
                </h6>
                <!-- کادر رمز یکبار مصرف -->
                <div class="input-group my-4">
                    <input
                        type="text"
                        v-model="recoveryCode"
                        class="form-control text-center rounded-0"
                        placeholder="رمز یکبار مصرف پیامک شده را وارد نمایید"
                        autocomplete="off"
                        v-on:focus="$event.target.select()"
                        v-on:keypress="onlyNumberAccept"
                        v-on:keyup.enter="callLoginUserBySMS()"
                        style="direction: ltr"
                        maxlength="5"
                    />
                </div>
                <div v-if="errorMessage != ''" class="row m-0 p-0 mb-3 justify-content-center">
                  <span 
                    class="h6 text-danger text-center"
                    style="white-space: pre; line-height: 28px;"
                  >{{errorMessage}}</span>
                </div>
                <!-- دکمه تایید و ورود و بازگشت پایین فرم -->
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div
                      class="
                          d-inline-flex
                          justify-content-end
                          align-items-center
                          bg-secondary
                          rounded
                          hoverable
                          waves-effect
                      "
                    >
                      <a
                          v-on:click="callLoginUserBySMS()"
                          class="text-decoration-none px-4 py-2 text-white m-0 h6"
                      >
                          تایید و ورود
                      </a>
                      <a
                          v-on:click="callLoginUserBySMS()"
                          style="background-color: #623879"
                          class="
                          text-decoration-none
                          p-2
                          py-3
                          text-white
                          m-0
                          rounded-left
                          "
                      >
                        <span class="p-0 m-0 h6 text-white">{{timeLeft}}</span>
                      </a>
                    </div>
                  </div>
                  <div
                    class="
                      d-inline-flex
                      justify-content-end
                    "
                  >
                    <a
                      v-on:click="backToLogin()"
                      class="
                        m-0
                        h7
                        text-info
                        mt-2
                      "
                      title="بازگشت به فرم ورود"
                    >
                      بازگشت
                      <i class="fas fa-sign-out-alt fa-rotate-180 fa-lg mr-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { newRoutes } from "../../main";

export default {
  data() {
    return {
      intervalTimer: null,          // تایمر شمارنده زمان
      maxTimeForInserSMSCode: 300,  // مدت انتظار جهت درج کد بازیابی - 300 ثانیه
      timeLeft: "00:00",            // مدت انتظار جهت نمایش به کاربر
      checkSendSMS: false,          // کنترل وضعیت ارسال پیامک کد بازیابی
      mobilNumber: '',               // تلفن همراه کاربر
      recoveryCode: '',             // کد بازیابی دریافتی از پیامک
      errorMessage: '',
    };
  },
  computed: {
    ImageUrl() {
      // بازیابی آدرس تصاویر
      return this.$store.getters.getImageUrl;
    },
    getVersionApp() {
      // بازیابی شماره نگارش نرم افزار
      return this.$store.getters.getVersionApp;
    },
  },
  methods: {
    // درج فقط عدد مجاز است
    onlyNumberAccept($event) {
      this.errorMessage = '';
      if (!/\d/.test($event.key)) {
        return $event.preventDefault();
      }
    },
    // مربوط به دکمه بازگشت
    backToLogin(){
      newRoutes.push("Login");
    },
    // مربوط به دکمه ارسال پیامک رمز یکبار مصرف
    async checkMobileNumber() {
      if(this.mobilNumber != ''){
        if(this.mobilNumber.length >= 10 && this.mobilNumber.length <= 11){
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: "ارسال پیامک رمز یکبار مصرف",
          });
          // ارسال پیامک رمز یکبار مصرف
          var strSendSMS = await this.$store.dispatch("sendSMSForLoginByMobile", { mobilNumber: this.mobilNumber});
          if(strSendSMS === "true"){
              // شمارش معکوس ارسال مجدد پیامک
              this.checkSendSMS = true;
              this.setTime(this.maxTimeForInserSMSCode);
              this.errorMessage = '';
          } else {
            this.errorMessage = strSendSMS;
          }
          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        } else {
          // طول تلفن همراه درج شده ، معتبر نمی باشد
          this.errorMessage = "طول تلفن همراه معتبر نمی باشد !";
          this.$store.dispatch("notify", {
            notText: this.errorMessage,
            timeOut: 2500,
          });
        }
      } else {
        // تلفن همراه درج نشده است
        this.errorMessage = "تلفن همراه درج نشده است !\nدرج تلفن همراه ، الزامی است .";
        this.$store.dispatch("notify", {
          notText: this.errorMessage,
          timeOut: 3500,
        });
      }
    },
    async callLoginUserBySMS(){
      if(this.recoveryCode != ''){
        if(this.recoveryCode.length >= 5){
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: "ورود به میزکار",
          });
          // ورود با رمز یکبار مصرف پیامک شده
          var strRecoveryPassword = await this.$store.dispatch("LoginBySMSPassword", { mobilNumber: this.mobilNumber, recoveryCode: this.recoveryCode});
          if(strRecoveryPassword === "true"){
              // ورود موفق بود - مراجعه به میزکار
              this.checkSendSMS = false;
              newRoutes.push("AdminPanel");
              this.errorMessage = '';
          } else {
            this.errorMessage = strRecoveryPassword;
          }
          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        } else {
          // طول رمز یکبار مصرف ، معتبر نمی باشد
          this.errorMessage = "طول رمز یکبار مصرف ، معتبر نمی باشد !\nحداقل طول رمز یکبار مصرف ، 5 رقم است .";
          this.$store.dispatch("notify", {
            notText: this.errorMessage,
            timeOut: 2500,
          });
        }
      } else {
        // رمز یکبار مصرف ، درج نشده است
        this.errorMessage = "رمز یکبار مصرف ، درج نشده است !\nدرج رمز یکبار مصرف ، الزامی است .";
        this.$store.dispatch("notify", {
          notText: this.errorMessage,
          timeOut: 3500,
        });
      }
    },
    // تابع شروع تایمر
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);

      this.selectedTime = seconds;
      this.countdown(end);
    },
    countdown(end) {
      // this.initialTime = this.selectedTime;
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);

        if (secondsLeft <= 0) {
          clearInterval(this.intervalTimer);
          // پایان زمان درج کد بازیابی
          this.checkSendSMS = false;
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      this.timeLeft =
        minutes.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) +
        ":" +
        seconds.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/LoginByMobile/LoginByMobile.vue